module.exports = __webpack_public_path__ + "static/img/03.82a49d55.jpg";